// import axios from "axios";
import {Notification} from 'element-ui';
import {merge} from 'lodash'
import Vue from 'vue'
import {http} from 'pm-utils'


/**
 * 实例化
 * config是库的默认值，然后是实例的 defaults 属性，最后是请求设置的 config 参数。后者将优先于前者
 */
// const http = axios.create({
//     timeout: 1000 * 30,
//     withCredentials: true,
//     headers: {
//         'X-Requested-With': 'XMLHttpRequest',
//         'Content-Type': 'application/json; charset=utf-8'
//     }
// });

/**
 * 请求拦截
 */
http.axios.instance.interceptors.request.use(function (config) {
    config.headers['access_token'] = localStorage.getItem('access_token') || '' // 请求头带上token
    config.headers['token'] = localStorage.getItem('access_token') || ''
    return config;
}, function (error) {
    return Promise.reject(error);
});

/**
 * 响应拦截
 */
http.axios.instance.interceptors.response.use(response => {
    if (response.data.code) {
        if (response.data.code === '1') {
            return response;
        }
        if (response.data.code === '1003') {
            // 如果不需要提示，返回其他code码
            // return window.location.href = window.$config.label === 'web6' ? '/login' : response.data.redirectUrl;
        }
        if (response.data.code === '1001') {
            Notification({
                title: '错误提示',
                showClose: true,
                message: response.data.msg,
                type: 'warning'
            })
        }
        return Promise.reject(response);
    }
    return response; // 注意在编写框架不要返回到了data层
}, error => {
    return Promise.reject(error);
})

const post = (url, params = {}, config = {}) => {
    config = merge({
        ...config,
        baseURL: config.baseURL ? adornUrl+config.baseURL : adornUrl,
    })
    return http.axios.post(url, params, config)
}

const get = (url, params = {}, config = {}) => {
    config = merge({
        ...config,
        baseURL: config.baseURL ? adornUrl+config.baseURL : adornUrl,
    })
    return http.axios.get(url, params, config)
}

/**
 * 请求地址处理
 */
const resetApiInstanceUrl = (url) => {
    return adornUrl + url
}

let adornUrl = ''
const updateAdornUrl = (projectAdornUrl) => {
    adornUrl = projectAdornUrl
    console.log('updateAdornUrl', adornUrl)
}

export default http;
export {
    post,
    get,
    resetApiInstanceUrl,
    updateAdornUrl,
}
